module.exports = __webpack_public_path__ + "img/btcz.ff60f175.svg";